import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
export function GuaranteeSection() {
  return <section aria-labelledby="garantia" className="bg-white text-brand-navy" data-id="element-89" data-mp="4vrzzwt0kbqc">
      <div className="mx-auto max-w-xl px-3 py-5 text-center sm:px-5" data-id="element-90" data-mp="9tbduvlsumhr">
        <p className="font-display text-[0.62rem] font-bold uppercase tracking-[0.14em] text-brand-blue" data-id="element-91" data-mp="et67h6wylq6i">
          Tu inversión está protegida
        </p>

        <Reveal className="mt-2 flex items-start gap-3 rounded-xl border-2 border-brand-blue bg-brand-gray p-3 text-left" data-id="element-92" data-mp="jsaeps0bpdu7">
          <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-brand-blue" data-id="element-93" data-mp="nrrnaub1qr3l">
            <ShieldCheckIcon size={20} className="text-white" data-id="element-94" data-mp="xjntksnadniw" />
          </span>
          <div data-id="element-95" data-mp="xlrvj51mkcgj">
            <h2 id="garantia" className="font-display text-sm font-extrabold uppercase leading-tight sm:text-base" data-id="element-96" data-mp="12ja7737115s8">
              🛡️ Garantía total de 7 días
            </h2>
            <p className="mt-0.5 text-[0.78rem] leading-snug text-slate-700" data-id="element-97" data-mp="25s71sim5hf8d">
              Tienes 7 días para explorar los 6 tomos y los 5 bonos. Si
              consideras que el sistema no es adecuado para ti, puedes
              solicitar un reembolso dentro del período establecido según los
              términos de devolución.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}